import { MouseEvent, useEffect, useRef, useState } from 'react';
import { HamburgerIcon } from '../ui/HamburgerIcon';

interface PdfDropdownProps {
  menuTitle?: string;
  subject?: string;
  scrolledPast?: boolean;
  children: (closeDropdown: () => void) => React.ReactNode;
}

export const PdfDropdown: React.FC<PdfDropdownProps> = ({
  menuTitle = 'Innehållsförteckning',
  scrolledPast,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const [dropdownPosition, setDropdownPosition] = useState(0);

  const toggleDropdown = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (!isOpen && menuRef.current) {
      menuRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
    setIsOpen(!isOpen);
  };

  const closeDropdown = () => setIsOpen(false);

  useEffect(() => {
    const stickyHeader = document.querySelector('.snb-parent');
    if (!stickyHeader) return;
    setDropdownPosition(stickyHeader.clientHeight);
    const handleResize = () => {
      setDropdownPosition(stickyHeader.clientHeight);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      <div
        ref={menuRef}
        className="w-full max-w-screen-kia-sm"
        style={{
          top: `${scrolledPast ? dropdownPosition : 0}px`,
          position: scrolledPast ? 'fixed' : 'relative',
        }}
      >
        <div>
          <div className="flex p-2 flex-row gap-2 bg-white items-center border-gray-200 border-b-2">
            <button
              onClick={(e) => toggleDropdown(e)}
              className="z-20 text-lg font-semibold flex items-center gap-2 bg-dark-blue text-white py-2 px-2"
            >
              <HamburgerIcon isOpen={isOpen} strokeColor="#000000" />
              
              {menuTitle}
            </button>
          </div>
          {isOpen && children(closeDropdown)}
        </div>
      </div>
      {scrolledPast ? <div style={{ height: '60px' }} /> : null}
    </>
  );
};
